import anime from 'animejs';

document.addEventListener('DOMContentLoaded', () => {
	const dotEls = document.querySelectorAll<HTMLElement>('[data-dot-from]');
	dotEls.forEach((fromEl) => {
		const toSelector = fromEl.getAttribute('data-dot-from');
		const toEl = toSelector
			? document.querySelector<HTMLElement>(toSelector)
			: null;
		const subsequentDotsSelector = fromEl.getAttribute('data-dots-subsequent');
		const subsequentDots = subsequentDotsSelector
			? document.querySelectorAll<HTMLElement>(subsequentDotsSelector)
			: null;

		if (!toSelector || !toEl) return;

		toEl.style.opacity = '0';

		if (subsequentDots) {
			subsequentDots.forEach((dot) => (dot.style.opacity = '0'));
		}

		let animated = false;
		const move = () => {
			if (animated) return;
			animated = true;

			const styles = getComputedStyle(fromEl);

			fromEl.style.backgroundColor = styles.getPropertyValue(
				'background-color',
			);
			toEl.style.backgroundColor = styles.getPropertyValue('background-color');

			fromEl.style.animation = 'none';

			const fromRect = fromEl.getBoundingClientRect();
			const toRect = toEl.getBoundingClientRect();

			const params: anime.AnimeParams = {
				duration: 1000,
				easing: 'cubicBezier(0.9, 0.01, 0.28, 1.02)',
			};

			// From
			anime({
				targets: fromEl,
				translateX: toRect.left - fromRect.left,
				translateY: toRect.top - fromRect.top,
				scaleX: toRect.width / fromRect.width,
				scaleY: toRect.height / fromRect.height,
				opacity: {
					value: 0,
					duration: 10,
					delay: 950,
					easing: 'linear',
				},
				...params,
			});

			// To
			anime({
				targets: toEl,
				translateX: [fromRect.left - toRect.left, 0],
				translateY: [fromRect.top - toRect.top, 0],
				scaleX: [fromRect.width / toRect.width, 1],
				scaleY: [fromRect.height / toRect.height, 1],
				opacity: {
					value: 1,
					duration: 10,
					delay: 50,
					easing: 'linear',
				},
				...params,
				complete: () => {
					if (!subsequentDots) return;
					anime({
						targets: subsequentDots,
						duration: 2000,
						opacity: [0, 1],
						delay: (_, i) => 100 + i * 300,
						easing: 'easeOutQuad',
					});
				},
			});
		};

		const observer = new IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) {
					move();
				}
			},
			{
				threshold: 1,
				rootMargin: '-10px',
			},
		);
		observer.observe(toEl);
	});
});
